/**
 * Modale de confirmation (plus de window.confirm).
 */
import { useEffect } from "react";
import { Button } from "./Button";
import "./confirmModal.css";

type ConfirmModalProps = {
  open: boolean;
  title: string;
  message?: string;
  confirmLabel?: string;
  busyLabel?: string;
  cancelLabel?: string;
  confirmVariant?: "primary" | "danger";
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmModal({
  open,
  title,
  message,
  confirmLabel = "Supprimer",
  busyLabel,
  cancelLabel = "Annuler",
  confirmVariant = "danger",
  busy = false,
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !busy) onCancel();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, busy, onCancel]);

  if (!open) return null;

  return (
    <div className="fx-modal" role="dialog" aria-modal="true" aria-labelledby="fx-modal-title">
      <button type="button" className="fx-modal__backdrop" aria-label="Fermer" disabled={busy} onClick={onCancel} />
      <div className="fx-modal__card">
        <h2 id="fx-modal-title" className="fx-modal__title">
          {title}
        </h2>
        {message ? <p className="fx-modal__text">{message}</p> : null}
        <div className="fx-modal__actions">
          <Button variant="ghost" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </Button>
          <Button variant={confirmVariant} onClick={onConfirm} disabled={busy}>
            {busy ? busyLabel || "Suppression…" : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}
